export { SearchResultsV2 } from './SearchResultsV2';
